import React, { useEffect, useState } from 'react'
import { Box, Typography } from '@material-ui/core'
import Breadcrumb from '../../Components/Breadcrumbs'
import { useStyles } from './style'
import hand from '../../Assets/Images/hand.svg'
import rocket from '../../Assets/Images/rocket.svg'
import presentation from '../../Assets/Images/presentation.svg'
import activate from '../../Assets/Images/activate.svg'
import key from '../../Assets/Images/key.svg'
import biarrow from '../../Assets/Images/biarrow.svg'
import documentImg from '../../Assets/Images/document.svg'
import app from '../../Assets/Images/app.svg'
import darkDocumentImg from '../../Assets/Images/darkDocumentImg.svg'
import darkAppImg from '../../Assets/Images/darkAppImg.svg'
import betaTag from '../../Assets/Icons/betaTag.png'
import { ChevronRight } from '@material-ui/icons'
import { connect } from 'react-redux'
import { accountService } from '../../Services/AccountService/AccountService'
import * as messageTypes from '../../utils/messageTypes'
import _ from 'lodash'
import { COMMON } from '../../utils/constants'
import { DisplayMessage } from '../../Components'
import { developerHubService } from '../../Services/DeveloperHubService'
import getConfig from '../../Config/env'

function DeveloperHub(props) {
  const classes = useStyles()
  const [openMessage, setOpenMessage] = useState(false)
  const [message, setMessage] = useState()
  const [messageType, setMessageType] = useState()
  const [showMetrics, setShowMetrics] = useState(props.isSuperAdmin)
  const [showStatusPage, setShowStatusPage] = useState(props.isSuperAdmin)

  const subCardMouseEnter = () => {
    const cardWrappers = Array.from(document.getElementsByClassName(classes.cardWrapper))
    cardWrappers.forEach(cardWrapper => {
      cardWrapper.classList.add(classes.customCardWrapper)
    })
  }

  const subCardMouseLeave = () => {
    const cardWrappers = Array.from(document.getElementsByClassName(classes.cardWrapper))
    cardWrappers.forEach(cardWrapper => {
      cardWrapper.classList.remove(classes.customCardWrapper)
    })
  }

  const subCardTextMouseEnter = () => {
    const dataCards = Array.from(document.getElementsByClassName(classes.apiDataCard))
    dataCards.forEach(dataCards => {
      dataCards.classList.add(classes.customSubCard)
    })
  }

  const subCardTextMouseLeave = () => {
    const dataCards = Array.from(document.getElementsByClassName(classes.apiDataCard))
    dataCards.forEach(dataCards => {
      dataCards.classList.remove(classes.customSubCard)
    })
  }

  const handleMessageClose = (event, reason) => {
    if (reason === COMMON.CLICKAWAY) {
      return
    }

    setOpenMessage(false)
    setOpenMessage(false)
  }

  const getAccountDetails = () => {
    const params = { account_id: props.currentUser.account_id }
    accountService.getAccountDetails(params)
      .then(accountData => {
        setShowMetrics(_.get(accountData, 'account.api_usage_and_metrics_enabled', false))
        setShowStatusPage(_.get(accountData, 'account.vpp_status_page_enabled', false))
      })
      .catch(error => {
        setOpenMessage(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Failed to get account details'))
        setMessageType(messageTypes.ERROR)
      })
  }

  useEffect(() => {
    if (!(props.isSuperAdmin || props.isViewOnly) && props.currentUser)
      getAccountDetails()
  }, [props.isSuperAdmin, props.currentUser])

  const handleStatusPage = () => {
    const config = getConfig()

    if (config.requiresStatusPageToken) {
      developerHubService.getStatusPage(props.currentUser.account_id)
        .then(response => {
          const token = response.data.token
          window.open(`${config.statusPageUrl}/auth?jwt=${token}`, '_blank')
        })
        .catch(error => {
          setOpenMessage(true)
          setMessage(_.get(error, 'error.displayMessage', 'Failed to open status page'))
          setMessageType(messageTypes.ERROR)
        })
    } else {
      window.open(config.statusPageUrl, '_blank')
    }
  }

  return (
    <>
      <Breadcrumb value={[{ 'Developer Hub': '/developer' }]} />
      <DisplayMessage open={openMessage} message={message} messageType={messageType} handleClose={handleMessageClose} />
      <Box className={classes.headerWrapper}>
        <Typography className={classes.title}>Developer Hub</Typography>
        <Box className={classes.subTitle}>Harness the power of data from Enphase Systems</Box>
      </Box>
      <Box className={classes.cardWrapper}>
        <Box mx={2} display="flex" alignItems="center" justifyContent="center" flexBasis="290px" flexWrap="wrap">
          <img className={classes.cardImg} src={hand} alt="" />
          <Box className={classes.cardTitle} onClick={() => props.history.push('/developer/introduction')} onMouseEnter={() => subCardMouseEnter()} onMouseLeave={() => subCardMouseLeave()}>
            <Box>Introduction</Box>
            <ChevronRight className={classes.cardTextArrow} />
          </Box>
        </Box>
        <Box display="flex" justifyContent="center" flexWrap="wrap">
          <Box className={classes.subCard} onClick={() => props.history.push('/developer/introduction#about-vpp')} onMouseEnter={() => subCardMouseEnter()} onMouseLeave={() => subCardMouseLeave()}>
            <img className={classes.subCardImg} src={presentation} alt="" />
            <Typography className={classes.subCardTitle}>About VPP API</Typography>
          </Box>
        </Box>
      </Box>
      <Box className={classes.cardWrapper}>
        <Box mx={2} display="flex" alignItems="center" justifyContent="center" flexBasis="290px" flexWrap="wrap">
          <img className={classes.cardImg} src={rocket} alt="" />
          <Box className={classes.cardTitle} onClick={() => props.history.push('/developer/getting-started')} onMouseEnter={() => subCardMouseEnter()} onMouseLeave={() => subCardMouseLeave()}>
            <Box>Getting Started </Box>
            <ChevronRight className={classes.cardTextArrow} />
          </Box>
        </Box>
        <Box display="flex" justifyContent="center" flexWrap="wrap">
          <Box className={classes.subCard} onClick={() => props.history.push('/developer/getting-started#create-your-first-app-client')} onMouseEnter={() => subCardMouseEnter()} onMouseLeave={() => subCardMouseLeave()}>
            <img className={classes.subCardImg} src={activate} alt="" />
            <Typography className={classes.subCardTitle}>Create your first App Client</Typography>
          </Box>
          <Box className={classes.subCard} onClick={() => props.history.push('/developer/getting-started#how-to-generate-access-token')} onMouseEnter={() => subCardMouseEnter()} onMouseLeave={() => subCardMouseLeave()}>
            <img className={classes.subCardImg} src={key} alt="" />
            <Typography className={classes.subCardTitle}>How to generate access token</Typography>
          </Box>
          <Box className={classes.subCard} onClick={() => props.history.push('/developer/getting-started#sample-request-and-response')} onMouseEnter={() => subCardMouseEnter()} onMouseLeave={() => subCardMouseLeave()}>
            <img className={classes.subCardImg} src={biarrow} alt="" />
            <Typography className={classes.subCardTitle}>Sample Request and Response</Typography>
          </Box>
        </Box>
      </Box>
      <Box className={classes.cardWrapper}>
        <Box mx={2} display="flex" alignItems="center" justifyContent="center" flexBasis="290px" flexWrap="wrap">
          <img className={classes.cardImg} src={documentImg} alt="" />
          <Box className={classes.cardTitle} onMouseEnter={() => subCardMouseEnter()} onMouseLeave={() => subCardMouseLeave()}>
            <Box>Documentation </Box>
            <ChevronRight className={classes.cardTextArrow} />
          </Box>
        </Box>
        <Box display="flex" justifyContent="center" flexWrap="wrap">
          <Box className={classes.subCard} onClick={() => props.history.push('/developer/cloud-api')} onMouseEnter={() => subCardMouseEnter()} onMouseLeave={() => subCardMouseLeave()}>
            <img className={classes.subCardImg} src={darkDocumentImg} alt="" />
            <Typography className={classes.subCardTitle}>Cloud API</Typography>
          </Box>
          {!props.isViewOnly &&
            <Box className={classes.subCard} onClick={() => props.history.push('/developer/product-limitations')} onMouseEnter={() => subCardMouseEnter()} onMouseLeave={() => subCardMouseLeave()}>
              <img className={classes.subCardImg} src={darkAppImg} alt="" />
              <Typography className={classes.subCardTitle}>Product Limitations</Typography>
            </Box>
          }
          {!props.isViewOnly &&
            <Box className={classes.subCard} onClick={() => props.history.push('/developer/oauth-guide')} onMouseEnter={() => subCardMouseEnter()} onMouseLeave={() => subCardMouseLeave()}>
              <img className={classes.subCardImg} src={darkDocumentImg} alt="" />
              <Typography className={classes.subCardTitle}>OAuth Guide</Typography>
            </Box>
          }
          {!props.isViewOnly &&
            <Box className={classes.subCard} onClick={() => window.open('https://enphase.com/download/iq-gateway-local-apis-or-ui-access-using-token', '_blank')} onMouseEnter={() => subCardMouseEnter()} onMouseLeave={() => subCardMouseLeave()}>
              <img className={classes.subCardImg} src={darkAppImg} alt="" />
              <Typography className={classes.subCardTitle}>Local API</Typography>
            </Box>
          }
          <Box className={classes.subCard} onClick={() => props.history.push('/developer/release-notes')} onMouseEnter={() => subCardMouseEnter()} onMouseLeave={() => subCardMouseLeave()}>
            <img className={classes.subCardImg} src={darkDocumentImg} alt="" />
            <Typography className={classes.subCardTitle}>Release Notes</Typography>
          </Box>
        </Box>
      </Box>
      {!props.isViewOnly &&
        <Box className={classes.cardWrapper}>
          <Box mx={2} display="flex" alignItems="center" justifyContent="center" flexBasis="290px" flexWrap="wrap">
            <img className={classes.cardImg} src={app} alt="" />
            <Box className={classes.cardTitle} onMouseEnter={() => subCardMouseEnter()} onMouseLeave={() => subCardMouseLeave()}>
              <Box>API Dashboard </Box>
              <ChevronRight className={classes.cardTextArrow} />
            </Box>
          </Box>
          <Box display="flex" justifyContent="center" flexWrap="wrap">
            <Box className={classes.subCard} onClick={() => props.history.push('/developer/api-credentials')} onMouseEnter={() => subCardMouseEnter()} onMouseLeave={() => subCardMouseLeave()}>
              <img className={classes.subCardImg} src={darkAppImg} alt="" />
              <Typography className={classes.subCardTitle}>API Credentials</Typography>
            </Box>
          </Box>
          {showStatusPage && 
            <Box display="flex" justifyContent="center" flexWrap="wrap">
              <Box className={classes.subCard} onClick={handleStatusPage} onMouseEnter={() => subCardMouseEnter()} onMouseLeave={() => subCardMouseLeave()}>
                <img className={classes.betaTag} src={betaTag} alt="beta" />
                <img className={classes.subCardImg} src={darkDocumentImg} alt="" />
                <Typography className={classes.subCardTitle}>VPP Health Monitor</Typography>
              </Box>
            </Box>
          }
          {showMetrics &&
            <Box display="flex" justifyContent="center" flexWrap="wrap">
              <Box className={classes.subCard} onClick={() => props.history.push('/developer/api-usage-and-metrics')} onMouseEnter={() => subCardMouseEnter()} onMouseLeave={() => subCardMouseLeave()}>
                <img className={classes.subCardImg} src={presentation} alt="" />
                <Typography className={classes.subCardTitle}>Usage and Metrics</Typography>
              </Box>
            </Box>
          }
        </Box>
      }
    </>
  )
}

const mapStateToProps = ({ auth }) => {
  const { isViewOnly, isSuperAdmin, currentUser } = auth
  return { isViewOnly, isSuperAdmin, currentUser }
}

export default connect(mapStateToProps, {})(DeveloperHub)